import { render } from "./CustomSkillTree.vue?vue&type=template&id=50623a7a"
import script from "./CustomSkillTree.vue?vue&type=script&lang=js"
export * from "./CustomSkillTree.vue?vue&type=script&lang=js"

import "./CustomSkillTree.vue?vue&type=style&index=0&id=50623a7a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__